import {
  createFrontendPlugin,
  FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import {
  EntityContentBlueprint,
  EntityCardBlueprint,
} from '@backstage/plugin-catalog-react/alpha';

import { rootRouteRef } from './routes';

// manage resources
const manageResource = EntityContentBlueprint.make({
  params: {
    path: 'manage',
    title: 'Manage',
    loader: () =>
      import('./components/ManageResource').then(m => <m.ManageResource />),
    filter: { 'spec.type': 'kratix-resource' },
  },
});

const promiseStatusCard = EntityCardBlueprint.make({
  name: 'promise-status', // → ID: entity-card:my-plugin/my-card
  params: {
    type: 'content', // 'info' (compact) or 'content' (full-width)
    filter: {
      'spec.type': { $in: ['kratix-promise', 'kratix-resource'] },
    },
    loader: async () =>
      import('./components/StatusCard').then(m => <m.StatusCard />),
  },
});

export const atosPromisePlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'atos-promise',
  extensions: [manageResource, promiseStatusCard],
  routes: {
    root: rootRouteRef,
  },
});
